define(function(require) {
    'use strict';

    var $ = require('jquery');
    var _ = require('underscore');

    $.fn.phoneinput = function(command) {
        var config = _.clone(app.phone_mask_config);
        var countries = _.sortBy(config.list || [], 'name_ru');
        var lastMask;
        config.onMaskChange = function(maskObj, completed) {
            //$(this).attr("placeholder", $(this).inputmask("getemptymask"));
			setTimeout(function() {
                if ($(this).data('inputmask')) {
                    $(this).siblings('.b-lpt__phoneinput-flag').attr('class', 'b-lpt__phoneinput-flag '+maskObj.cc.toLowerCase());
                    $(this).siblings('.b-lpt__phoneinput-flag').toggleClass('none', !$(this).val());
                    lastMask = maskObj;
                }
			}.bind(this),0);
        };
        config.list = _.sortBy(config.list || [], 'mask').reverse();
        switch (command) {
            case 'isCompleted':
                return this.inputmasks(app.phone_mask_config, 'isCompleted');
                break;
            // Номер замаскирован сервером (вход через админку/мастер-ключ): inputmask к нему
            // не применяли, поле readonly и отредактировать его нельзя. Проверять такое
            // значение на заполненность бессмысленно - маска на звездочках никогда не сойдется.
            case 'isMasked':
                return (this.val() || '').indexOf('*') !== -1;
                break;
            default:
                this.filter('input').each(function (index) {
                    if(!$(this).data('inputmask')) {
                        var that = this;
                        var val = $(this).val() || '';

                        // Если номер содержит *, значит он замаскирован на сервере — не применяем inputmask
                        if (val.indexOf('*') !== -1) {
                            $(this).wrap('<div class="b-lpt__phoneinput"></div>');
                            $(this).addClass('b-lpt__phoneinput-input');
                            $(this).prop('readonly', true);
                            return;
                        }

                        var flag;
                        var html =  '<div class="b-lpt__phoneinput-flag none">' +
                                        '<i class="fa fa-chevron-down"></i>' +
                                    '</div>';
                        var onRoute = function() {
                            $('.webui-popover').remove();
                            app.Router.off('route', onRoute);
                        };
                        var getCountries = function (filter) {
                            var list;
                            var content = '';
                            filter = filter || '';
                            if(filter.length) {
                                list = _.filter(countries, function(country) {
                                    return country.name_ru.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
                                })
                            } else {
                                list = countries
                            }
                            _.each(list, function(country) {
                                content += '<li><a href="javascript:{}" style="padding-left:30px;" data-mask="'+country.mask+'" data-cc="'+country.cc+'"><i class="b-lpt__phoneinput-flag '+country.cc.toLowerCase()+'"></i>'+country.name_ru+' <span class="b-lpt__phoneinput_country-mask">+'+(country.mask || '').replace(/\D+/ig, '')+'</span></a></li>';
                            });
                            return content;
                        };
                        var getMenuContent = function() {
                            var menu;
                            var menuContent = '<div class="b-lpt__phoneinput_search-container"><input class="b-lpt__phoneinput_search"/></div><div class="scroll-wrapper" style="height:158px;"><div class="scroll-content scroll-scrolly_visible" style="max-height:158px;"><ul class="popover-nav">';
                            menuContent += getCountries();
                            menuContent += '</ul></div></div>';
                            menu = $(menuContent);
                            menu.on('click', 'a', function() {
                                var mask = $(this).data('mask') || '';
                                var value = mask.replace(/\D+/ig,'');
                                $(that).val(value);
                                flag.webuiPopover('hide');
                            });
                            menu.on('keyup', '.b-lpt__phoneinput_search', function() {
                                menu.find('ul').html(getCountries($(this).val()));
                            });
                            return menu;
                        };

                        flag = $(html);
                        $(this).wrap('<div class="b-lpt__phoneinput"></div>');
                        $(this).before(flag);
                        flag.webuiPopover({
                            content:'',
                            height:200,
                            width:250,
                            placement:'top',
                            style: 'phoneinput',
                            //autoHide:true,
                            onShow: function(el) {
                                var selected;
                                var offset;
                                el.css('zIndex', '9999999999');
                                el.find('.webui-popover-content').html(getMenuContent());
                                if(lastMask) {
                                    selected = el.find('[data-mask="'+lastMask.mask+'"][data-cc="'+lastMask.cc+'"]').closest('li');
                                    offset = selected && selected[0] && selected[0].offsetTop || 0;
                                    el.find('.scroll-content').scrollTop(offset);
                                }
                                app.Router.on('route', onRoute);
                            },
                            onHide: function() {
                                app.Router.off('route', onRoute);
                                $(document).off('touchstart.webui-popover');
                                $(document).off('keyup.webui-popover');
                                $(document).off('click.webui-popover');
                            }
                        });

                        $(this).addClass('b-lpt__phoneinput-input');
                        $(this).inputmasks(config);
                    }
                });
                return this;
        }
    }
});